import React from 'react';

export const assetUrl = (path) => `https://web.meeopp.com/${path}`;

export const StarIcon = (props) => <img {...props} src={assetUrl('icons/resized/star-icon.png')} />;
